module.exports = __webpack_public_path__ + "img/200.a6178f44.gif";